import { render } from "./PDFPrintComponent.vue?vue&type=template&id=1b2f71c2&scoped=true"
import script from "./PDFPrintComponent.vue?vue&type=script&lang=js"
export * from "./PDFPrintComponent.vue?vue&type=script&lang=js"

import "./PDFPrintComponent.vue?vue&type=style&index=0&id=1b2f71c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2f71c2"]])

export default __exports__